import { IngestFileType } from '../../common/domain/IngestFileType';
import { ColumnMapping } from './interfaces';
import { Schema } from './schema';
import { fileTypeToSchema } from './uploadMapping';

export const validateMappingSubmission = (
  mapping: ColumnMapping,
  fileType?: IngestFileType,
) => {
  let ignore = {
    USER_ID: true,
    INGEST_ID: true,
    GROUP_ID: true,
    DELETED: true,
    CCY_PAIR: false,
    TENOR: false,
  };

  // Ignore CCY_PAIR requirement if it is provided in 2 columns
  if (
    fileType?.internalType === 'FEP_SPOT' ||
    (fileType?.internalType === 'FEP_LINEAR' &&
      mapping['CURRENCY_1'] &&
      mapping['CURRENCY_2'])
  ) {
    ignore['CCY_PAIR'] = true;
  }

  // Ignore TENOR requirement if it is provided in 2 columns
  if (
    fileType?.internalType === 'FEP_LINEAR' &&
    mapping['TENOR1'] &&
    mapping['TENOR2']
  ) {
    ignore['TENOR'] = true;
  }

  // Ignore TENOR requirement if VALUE_DATE and MATURITY_DATE are provided
  if (
    fileType?.internalType === 'FEP_LINEAR' &&
    mapping['VALUE_DATE'] &&
    mapping['MATURITY_DATE']
  ) {
    ignore['TENOR'] = true;
  }

  let unmappedFields = fileTypeToSchema(fileType)
    ?.filter(
      (col) =>
        col.mode === 'REQUIRED' &&
        (ignore[col.name] == null || ignore[col.name] == false) &&
        mapping[col.name] == null,
    )
    .map((col) => col.name)
    .join(', ');
  if (unmappedFields != null && unmappedFields !== '') {
    return ['The following required columns must be mapped: ' + unmappedFields];
  }

  return [];
};
